import enquire from 'enquire.js';
import 'superfish/dist/js/superfish.js';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class Navigation {
	constructor() {
		this.site_header = '#site-header';
		this.search_form = '#searchform';
		this.primary_nav = '#primary-nav';
		this.courtesy_nav = '#courtesy-nav';
	}

	init() {
		this.menuToggle();
		this.superfishInit();
	}

	menuToggle() {
		const self = this;
		jQuery('#menu-toggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();
			jQuery(this).toggleClass('open');
			jQuery(self.primary_nav).toggleClass('menu-open');
			jQuery(self.site_header).toggleClass('menu-open');
			jQuery(self.search_form).removeClass('search-open');
			jQuery(self.site_header).removeClass('search-open');
			jQuery('#search-toggle').removeClass('open');
			jQuery('.search-field', self.search_form).blur();

			// Since the menu can open from different navbar positions, we adjust the height of the menu with js
			if (jQuery(self.primary_nav).hasClass('menu-open')) {
				const menuPosition =
					jQuery(self.primary_nav).offset().top - jQuery(document).scrollTop();
				jQuery(self.primary_nav).css({
					height: window.innerHeight - menuPosition + 'px',
				});
			} else {
				jQuery(self.primary_nav).css({ height: '' });
			}

			if (jQuery(this).hasClass('open')) {
				disableBodyScroll(document.querySelector(self.primary_nav));
			} else {
				clearAllBodyScrollLocks();
			}
		});

		jQuery('#search-toggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();

			jQuery(self.primary_nav).removeClass('menu-open');
			jQuery(self.site_header).removeClass('menu-open');
			jQuery('#menu-toggle').removeClass('open');

			if (jQuery(self.search_form).hasClass('search-open')) {
				self.hideSearch();
			} else {
				self.showSearch();
			}
		});

		jQuery(document).on('click', function (e) {
			if (jQuery(e.target).closest(self.search_form).length === 0) {
				self.hideSearch();
			}
		});
	}

	showSearch() {
		jQuery('#search-toggle').addClass('open');
		jQuery(this.search_form).addClass('search-open');
		jQuery(this.site_header).addClass('search-open');

		if (!jQuery('.search-field', this.search_form).is(':focus')) {
			jQuery('.search-field', this.search_form).focus();
		}
	}

	hideSearch() {
		jQuery('#search-toggle').removeClass('open');
		jQuery(this.search_form).removeClass('search-open');
		jQuery(this.site_header).removeClass('search-open');
	}

	superfishInit() {
		jQuery('.primary-menu .level-1').each(function () {
			jQuery(
				'<button class="submenu-toggle" aria-expanded="false"></button>',
			).insertAfter(jQuery('>a', jQuery(this).parent()));
		});

		const self = this;

		const submenuToggle = function (e) {
			e.stopPropagation();
			e.preventDefault();
			jQuery(this).toggleClass('open');
			if (jQuery(this).hasClass('open')) {
				this.setAttribute('aria-expanded', 'true');
				jQuery('ul', jQuery(this).parent()).stop().fadeIn('fast');
			} else {
				this.setAttribute('aria-expanded', 'false');
				jQuery('ul', jQuery(this).parent()).stop().fadeOut('fast');
			}
			jQuery('>.submenu', jQuery(this).parent()).toggleClass('open');
		};

		jQuery('.submenu-toggle').bind('click touchstart', submenuToggle);

		enquire.register('screen and (min-width:768px)', {
			match() {
				jQuery('.level-1', this.primary_nav).css('display', '');

				jQuery('.primary-menu').superfish({
					hoverClass: 'hover',
					delay: 600,
					animation: { opacity: 'show', height: 'show' },
					speed: 0,
					speedOut: 'fast',
					cssArrows: false,
				});

				jQuery(self.courtesy_nav).superfish({
					hoverClass: 'hover',
					delay: 1000,
					animation: { opacity: 'show', height: 'show' },
					speed: 50,
					speedOut: 'fast',
					cssArrows: false,
				});
			},
		});

		enquire.register('screen and (max-width:767px)', {
			match() {
				jQuery(self.courtesy_nav).superfish('destroy');
				jQuery('.primary-menu').superfish('destroy');
			},
		});
	}
}

const instance = new Navigation();
export default instance;
